import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";
import { SEO } from "../components/SEO";

export default function Legal({ page }) {
  const { t } = useLanguage();
  const title = t(`legal.${page}Title`);
  const body = t(`legal.${page}Body`);
  return (
    <div data-testid={`legal-${page}-page`}>
      <SEO title={`${title} — The Nice Picnic`} description={body} />
      <section className="pt-36 pb-24 max-w-3xl mx-auto px-5 sm:px-8">
        <Reveal>
          <h1 className="font-serif text-4xl sm:text-5xl text-ink">{title}</h1>
          <div className="w-16 h-px bg-gold mt-6" />
          <p className="mt-10 text-earth font-light leading-relaxed">{body}</p>
          <p className="mt-8 text-sm text-earth/70">hello@thenicepicnic.com · +33 6 52 88 21 60</p>
        </Reveal>
      </section>
    </div>
  );
}
